var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#92959D",
    d: "M6.508 17.841c-1.326 0-1.993-.654-1.993-1.961V8.123c0-1.308.667-1.968 1.993-1.968H17.49c1.333 0 1.993.66 1.993 1.968v7.757c0 1.307-.66 1.961-1.993 1.961H6.508Zm-.97-9.661v1.58H18.46V8.18c0-.66-.355-1.003-.984-1.003H6.521c-.635 0-.984.343-.984 1.003Zm10.689 1.104c-.432.007-.807-.374-.807-.812 0-.444.375-.819.807-.819.438 0 .806.375.806.819a.83.83 0 0 1-.806.812ZM5.537 13.29h12.924v-2.571H5.537v2.57Zm10.69-.489c-.432.006-.807-.374-.807-.813 0-.444.375-.818.807-.818.438 0 .806.374.806.819a.83.83 0 0 1-.806.812ZM6.52 16.819h10.956c.628 0 .984-.336.984-.996v-1.575H5.537v1.575c0 .66.35.996.984.996Zm9.706-.501c-.432.006-.807-.375-.807-.813 0-.444.375-.819.807-.819.438 0 .806.375.806.82a.83.83 0 0 1-.806.812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiServer);
export default __webpack_public_path__ + "static/media/multi-server.09c6590a0c8623c2a3c8c3e93e9f6faf.svg";
export { ForwardRef as ReactComponent };